module.exports = __webpack_public_path__ + "4bdeea225324c668b2c2f80a1527e9c4.png";